export default __webpack_public_path__ + "static/media/Meme_tool.f8978bf3.jpg";